import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const Logo = props => {
  const {
    classes,
    open,
    persistOpen,
    menuToggle,
    majorLogoUrl,
    minorLogoUrl
  } = props;
  return (
    <div className={classNames(classes.logoToolbar)}>
      <div
        className={classNames({
          [classes.propelLogo]: open,
          [classes.propelIcon]: !open
        })}
      >
        <img src={open ? majorLogoUrl : minorLogoUrl} alt="Logo" />
      </div>
      <IconButton
        onClick={menuToggle}
        classes={{
          root: classNames(classes.menuDefaultColor, classes.footerButton, {
            [classes.hidden]: !open
          })
        }}
      >
        {open && persistOpen ? <ArrowLeftIcon /> : <ArrowRightIcon />}
      </IconButton>
    </div>
  );
};
Logo.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  persistOpen: PropTypes.bool.isRequired,
  menuToggle: PropTypes.func.isRequired
};

export default Logo;
